module.exports = __webpack_public_path__ + "static/index/img/baikal-506.6ed344fe.jpg";